const SENSITIVITY_TYPE_LABELS = {
  Camera: 'Camera',
  ADS: 'ADS no dedo',
  Gyro: 'Giroscopio',
  'ADS Gyro': 'ADS Gyro'
};

const formatWeaponLabel = (slots = {}) => (
  slots.weaponLabel || (slots.weapon === 'm762' ? 'Beryl M762' : String(slots.weapon || 'arma').toUpperCase())
);

const formatScopeLabel = (slots = {}) => {
  if (slots.baseScopeLabel) return slots.baseScopeLabel;
  if (slots.baseScope === 'red_dot') return 'Red Dot';
  return slots.baseScope || 'mira base';
};

export const getPubgSensitivityTypeLabel = (sensitivityType) => (
  SENSITIVITY_TYPE_LABELS[sensitivityType] || sensitivityType || 'sensibilidade'
);

export const buildPubgCalculatorResultMetadata = (slots = {}, payload = {}) => ({
  game: 'pubg_mobile',
  weapon: slots.weapon || null,
  weaponLabel: formatWeaponLabel(slots),
  baseScope: slots.baseScope || null,
  baseScopeLabel: formatScopeLabel(slots),
  baseValue: slots.baseValue ?? null,
  sensitivityType: slots.sensitivityType || null,
  sensitivityTypeLabel: getPubgSensitivityTypeLabel(slots.sensitivityType),
  controlMode: payload.controlMode || slots.controlMode || null
});

export const renderPubgCalculatorResult = (apiResult = {}, { slots = {}, payload = {} } = {}) => {
  const rows = Array.isArray(apiResult.rows)
    ? apiResult.rows
    : (Array.isArray(apiResult.results) ? apiResult.results : []);
  const metadata = buildPubgCalculatorResultMetadata(slots, payload);
  const hasContext = Boolean(metadata.weapon && metadata.baseScope && metadata.baseValue && metadata.sensitivityType);

  return {
    type: 'conversation_result',
    title: hasContext
      ? `PUBG Mobile - ${metadata.weaponLabel} - ${metadata.sensitivityTypeLabel}`
      : 'Sensibilidade PUBG calculada',
    summary: hasContext
      ? `Base usada: ${metadata.baseScopeLabel} ${metadata.baseValue}. Estes valores sao de ${metadata.sensitivityTypeLabel}.`
      : 'Use esses valores como base e teste em spray curto antes de aplicar no ranked.',
    rows: rows.map((row) => ({
      label: row.scopeLabel || row.scope_label || row.scope || row.label || 'Mira',
      value: row.value
    })),
    metadata,
    copyText: apiResult.copyText || null,
    nextStep: 'Se quiser outro modo, me diga o tipo exato para eu nao misturar Camera, ADS, Gyro e ADS Gyro.'
  };
};

export const renderPubgCalculatorHumanError = ({ status = null, message = null } = {}) => {
  const safeMessage = message && !/^[A-Z0-9_]+$/.test(String(message)) ? message : null;

  if (status === 401) {
    return 'Preciso que voce esteja logado para calcular sua sensibilidade.';
  }

  if (status === 403) {
    return safeMessage || 'Essa calculadora depende do seu acesso atual. Se quiser, posso te mostrar os planos ou seguir com Sensi-IA.';
  }

  if (status >= 500) {
    return 'A engine da calculadora nao respondeu agora. Tenta novamente em instantes.';
  }

  return safeMessage || 'Nao consegui calcular com esses dados. Confere arma, mira base, valor numerico e tipo de sensibilidade.';
};

export default renderPubgCalculatorResult;
